import React from 'react';
import DepositIrt from "../../../pages/Trade/EasyTrade/EasyTradeWidget/components/DepositIrt/DepositIrt";

interface IBalanceAccountBase {
  onBalanceDone: () => void;
  isOpen: boolean;
}

const IS_MOBILE_SCREEN =
    window.innerWidth <= 600 ||
    (window.innerWidth <= 950 && window.innerHeight <= 450);

export const BalanceAccount: React.FC<IBalanceAccountBase> = ({
  onBalanceDone,
  isOpen = false,
}) => {

  return (
      <DepositIrt
        isMobileScreen={IS_MOBILE_SCREEN}
        onClose={onBalanceDone}
        showDeposit={isOpen} />
  );
};
